<template>
  <div class="view">
    <img src="@/assets/accroche.jpg" alt="">
    <img id="ll" src="@/assets/laurent_luqei.jpg" alt="">
    <landing-auth/>
  </div>
</template>

<script>
import LandingAuth from "@/components/Modals/LandingAuth";

export default {
  name      : "Landing",
  components: {LandingAuth}
}
</script>

<style scoped>

@media screen and (max-width: 599px) {
  img {
    width: 100%;
  }

  div.card {
    border-radius: 0;
    border-left: 0;
    border-right: 0;
    border-bottom: 0;
    margin: 0 !important;
  }
}

@media screen and (min-width: 600px) {
  img {
    max-height: 80vh;
    max-width: calc(100vw - 200px);
  }

  div.view {
    width: 100%;
    max-width: 1400px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  div.card {
    margin-top: 1.25rem !important;
  }
}

@media screen and (min-width: 600px) and (max-width: 1399px) {
  div.card {
    border-right: 0;
  }
}


#ll {
  display: none
}

@media screen and (max-width: 1400px) and (min-width: 600px) {
  div.card {
    min-width: 200px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}

@media screen and (min-width: 1100px) {
  #ll {
    display: inherit;
    max-height: 100vh;
  }
}
</style>